import { defaultFill } from '../../utils/constants';
var muiSuccessFill16 = {
    paths: [
        {
            path: 'M204,156 C208.418278,156 212,159.581722 212,164 C212,168.418278 208.418278,172 204,172 C199.581722,172 196,168.418278 196,164 C196,159.581722 199.581722,156 204,156 Z M207.367257,160 C207.240413,160 207.133481,160.025787 207.04646,160.077361 C206.95944,160.128934 206.877581,160.21843 206.800885,160.345848 L203.075221,166.407281 L201.168142,163.940842 C201.026549,163.758817 200.851032,163.667804 200.641593,163.667804 C200.455752,163.667804 200.30236,163.729238 200.181416,163.852105 C200.060472,163.974972 200,164.130451 200,164.318544 C200,164.403489 200.014012,164.484642 200.042035,164.562002 C200.070059,164.639363 200.119469,164.718999 200.190265,164.80091 L202.477876,167.690557 C202.643068,167.896852 202.848083,168 203.09292,168 C203.361357,168 203.567847,167.889268 203.712389,167.667804 L207.853982,161.096701 C207.90413,161.01479 207.941003,160.935912 207.964602,160.860068 C207.988201,160.784224 208,160.709898 208,160.637088 C208,160.452029 207.940265,160.299583 207.820796,160.17975 C207.701327,160.059917 207.550147,160 207.367257,160 Z',
            fill: defaultFill,
        },
    ],
    title: 'Success',
    width: 16,
    height: 16,
    translate: [-196, -156],
};
var muiSuccessFill = {
    base: muiSuccessFill16,
};
export { muiSuccessFill };
//# sourceMappingURL=successFill.js.map